import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { IUserProfileClaim } from '@gik/calendar/models/Claim';
import { useUserStore } from '@gik/core/store/UserStore';
import { useUpcomingClaims } from '@gik/api/users/claims';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import ClaimsListSkeleton from './ClaimsListSkeleton';
import ClaimsList from './ClaimsList';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '@gik/ui';

export interface IUpcomingClaimsListProps {
  items?: IUserProfileClaim[];
}

const blockName = 'claimed-items-list';

function UpcomingClaimsList({ items }: IUpcomingClaimsListProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  const userStore = useUserStore();
  const { data: claims, error: claimsError } = useUpcomingClaims(userStore.id, { initialData: items });

  const isLoading = !claims;
  const isError = isLoading && claimsError;

  if (isLoading) return <LoadingSpinner center />;
  if (isError) return <LoadingSpinner center />;

  return (
    <ClaimsList className={bem()} items={claims} loading={!claims} emptyText={t(translationKeys.emptyUpcomingClaims)} />
  );
}

export default withSuspense(UpcomingClaimsList, ClaimsListSkeleton);
